/** Up to two names shown, the rest counted, so a long audience stays one readable line. */
export const groupNamesSummary = (names: string[]): { shown: string[]; rest: number } => ({
  shown: names.slice(0, 2),
  rest: Math.max(names.length - 2, 0),
});
